import MobileNavMenu from '@/components/header/nav-menu/MobileNavMenu';
import RegularNavMenu from '@/components/header/nav-menu/RegularNavMenu';
import { Icons } from '@/components/icons';
import { TransText, type TransTextKeys } from '@/i18n/trans/text';
import type { NavigationItem } from '@/types/navigation';
import { breakpoints } from '@/utils/breakpoints';
import type { FC, ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

const Header: FC = () => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  const menuItems: Array<NavigationItem> = [
    {
      path: '/purchase',
      name: <TransText i18nKey="purchase" />,
      testId: 'purchase',
    },
    {
      path: '/manage-booking',
      name: <TransText i18nKey="manageBooking" />,
      testId: 'manage-booking',
    },
  ];

  const userMenuItems: Array<[TransTextKeys, string, ReactNode]> = [
    ['tickets', '/account/tickets', <Icons.ticket height={20} width={20} />],
    [
      'travelPasses',
      '/account/travel-passes',
      <Icons.travelPass height={20} width={20} />,
    ],
    ['loyalty', '/account/loyalty', <Icons.loyalty height={20} width={20} />],
    ['vouchers', '/account/vouchers', <Icons.wallet height={20} width={20} />],
    [
      'accountDetails',
      '/account/details',
      <Icons.user height={20} width={20} />,
    ],
    ['logOut', 'logout', <Icons.logOut height={20} width={20} />],
  ];

  const NavMenu = isLaptopOrBigger ? RegularNavMenu : MobileNavMenu;

  return (
    <header className="mx-auto flex h-14 w-full max-w-laptop flex-shrink-0 items-center bg-background px-4">
      <NavMenu menuItems={menuItems} userMenuItems={userMenuItems} />
    </header>
  );
};

export default Header;
